<template>
  <div v-if="formatAffiche">
    <header class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3"> {{ getTitle }} </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <button class="button is-addOrEdit" @click="$router.push({
              name: 'm.bodac.format_affiche',
              params: { id: formatAffiche.id }
            })">
              {{ $t('general.button.edit') }}
            </button>
          </div>
        </div>
      </div>
    </header>
    <section>
      <information-general-edit-detail
        :formatAffiche="formatAffiche"
        detail
        class="mgt-20px"/>
      <etape-information-edit-detail
        :formatAffiche="formatAffiche"
        detail
        class="mgt-20px"/>
    </section>
  </div>
</template>

<script>
import { get } from '@/api/formatAffiche/index';
import AppBreadcrumb from '@/components/general/breadcrumb';
import InformationGeneralEditDetail from '@/components/parametrage/formatAffiche/informationGeneralEditDetail';
import EtapeInformationEditDetail from '@/components/parametrage/formatAffiche/etapeInformationEditDetail';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'CFormatAffiche',
  components: {
    AppBreadcrumb,
    InformationGeneralEditDetail,
    EtapeInformationEditDetail,
  },
  data() {
    return {
      libelle: '',
      formatAffiche: null,
    };
  },
  computed: {
    getTitle() {
      return this.$t('detailFormatAffiche.title', { libelle: this.formatAffiche.libelle });
    },
    breadcrumb() {
      const output = [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('detailFormatAffiche.breadcrumb.liste'), route: { name: 'l.bodac.format_affiche' }, isActive: false },
        { title: this.getTitle, route: { name: '' }, isActive: true },
      ];
      return output;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.formatAffiche = (await get(this.$route.params.id)).data.result;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.formatAffiche.libelle }));
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
